const calanderDateConverter = (startDate, endDate) => {
  const startDateArr = startDate.toString().split(" ");
  const endDateArr = endDate.toString().split(" ");

  const date_str = `${startDateArr[1]} ${startDateArr[2]} - ${endDateArr[1]} ${endDateArr[2]} , ${startDateArr[3]}`;

  return date_str;
};

const dateConverter = (date) => {
  const arr = date.toString().split(" ");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date_str =
    arr[3] + "-" + (months.indexOf(arr[1]) + 1).toString() + "-" + arr[2];
  return date_str;
};

export { calanderDateConverter, dateConverter };
